import { createContext, useContext } from 'react'
import type { IconName } from './Icon'

export type ShowToast = (text: string, options?: { icon?: IconName }) => void

export const ToastContext = createContext<ShowToast | null>(null)

export function useToast(): ShowToast {
  const ctx = useContext(ToastContext)
  if (!ctx) throw new Error('useToast must be used inside <ToastProvider>')
  return ctx
}
